import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useDialectSdk } from '@dialectlabs/react-sdk';
import useSWR from 'swr';
import NoConnectionError from '../errors/ui/NoConnectionError';
const ERROR_MESSAGE = 'Error connecting to Dialect Cloud';
const fetcher = (...args) => fetch(...args).then((res) => res.json());
const useDialectHealth = ({ baseUrl, pollingInterval, }) => {
    const { data, error } = useSWR(`${baseUrl}/api/v1/health`, fetcher, {
        refreshInterval: pollingInterval,
        revalidateOnReconnect: true,
        refreshWhenHidden: true,
    });
    const isLoading = data === undefined && !error;
    return {
        isLoading,
        error: error === null || error === void 0 ? void 0 : error.message,
        isOK: (data === null || data === void 0 ? void 0 : data.status) === 'ok' && !error,
    };
};
const DEFAULT_CONNECTIVITY_POLLING_INTERVAL = 5000;
// TODO, pinging with sdk?
export default function ConnectionWrapper({ header, 
// fallback to a separate value, since this is more about the connection, rather than fetching functionality
// potentially can be a separate setting completely, TBD.
pollingInterval = DEFAULT_CONNECTIVITY_POLLING_INTERVAL, children, }) {
    const { config: { dialectCloud: { url: baseUrl }, }, } = useDialectSdk();
    const { isOK, error, isLoading } = useDialectHealth({
        baseUrl,
        pollingInterval,
    });
    const isConnected = isOK;
    if (typeof children === 'function') {
        return children({
            errorMessage: error ? ERROR_MESSAGE : undefined,
            isConnected,
            isLoading,
        });
    }
    if (!isConnected && !isLoading) {
        return (_jsxs(_Fragment, { children: [header, _jsx(NoConnectionError, { message: ERROR_MESSAGE })] }));
    }
    return _jsx(_Fragment, { children: children });
}
//# sourceMappingURL=ConnectionWrapper.js.map